import { render, staticRenderFns } from "./EditNoteSection.vue?vue&type=template&id=3b785b8b&scoped=true&"
import script from "./EditNoteSection.vue?vue&type=script&lang=js&"
export * from "./EditNoteSection.vue?vue&type=script&lang=js&"
import style0 from "./EditNoteSection.vue?vue&type=style&index=0&id=3b785b8b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b785b8b",
  null
  
)

export default component.exports